<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let store = offshoreOperationalStore;
  @let vm = offshoreReportStore.vm();
  <h1 class="mb-4 self-center text-xl">Miscellaneous</h1>

  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'captainName')"
    id="captainName"
    name="captainName"
    label="Captain Name"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('captainName')"
    [readonly]="isFieldReadOnly('captainName')"
    [value]="store.miscellaneous?.()?.captainName?.value"
    [ngModel]="store.miscellaneous?.()?.captainName?.value"
  />
  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'chiefEngineer')"
    id="chiefEngineer"
    name="chiefEngineer"
    label="Chief Engineer Name"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'chiefEngineer')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'chiefEngineer')"
    [value]="store.miscellaneous?.()?.chiefEngineer?.value"
    [ngModel]="store.miscellaneous?.()?.chiefEngineer?.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'cargoWeight')"
    name="cargoWeight"
    id="cargoWeight"
    label="Cargo Weight"
    [unit]="'MT'"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'cargoWeight')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'cargoWeight')"
    [min]="0"
    [value]="store.miscellaneous?.()?.cargoWeight?.value"
    [ngModel]="store.miscellaneous?.()?.cargoWeight?.value"
  />
  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'clientChartererName')"
    id="clientChartererName"
    name="clientChartererName"
    label="Client/Charterer Name"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'clientChartererName')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'clientChartererName')"
    [value]="store.miscellaneous?.()?.clientChartererName?.value"
    [ngModel]="store.miscellaneous?.()?.clientChartererName?.value"
  />
  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'supportVessels')"
    id="supportVessels"
    name="supportVessels"
    label="Support Vessels"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'supportVessels')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'supportVessels')"
    [value]="store.miscellaneous?.()?.supportVessels?.value"
    [ngModel]="store.miscellaneous?.()?.supportVessels?.value"
  />
  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'activityLog')"
    id="activityLog"
    name="activityLog"
    label="Activity Log"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'activityLog')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'activityLog')"
    [value]="store.miscellaneous?.()?.activityLog?.value"
    [ngModel]="store.miscellaneous?.()?.activityLog?.value"
  />
</form>
